import { Label } from "design-system/atoms/Label"
import { Textarea } from "design-system/atoms/Textarea"
import { useTranslation } from "react-i18next"

type Props = {
  value: string
  onChange: (value: string) => void
}

export function BusinessOpportunityDefinitionField({ value, onChange }: Props) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-1.5">
      <Label>{t("capabilities.catalog.BusinessOpportunity.config.definition.label")}</Label>
      <Textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t("capabilities.catalog.BusinessOpportunity.config.definition.placeholder")}
        rows={5}
        maxLength={1536}
      />
      <p className="text-sm text-muted-foreground">
        {t("capabilities.catalog.BusinessOpportunity.config.definition.description")}
      </p>
    </div>
  )
}
